module.exports = __webpack_public_path__ + "static/media/livedooh-dev-user-manual-2.18dc9b75.svg";